import http from '@/utils/http/index';

// 订阅列表
export function getSubscriptionList(params) {
  return http.get('/merContract/list', { params });
}

// 历史订阅交易记录
export function getSubscriptionTxnHistory(params) {
  return http.get('/merContract/getSubContractTxn', { params });
}

// 取消订阅
export function unsubscrible(params) {
  return http.get('/merContract/cancellSubContract', { params });
}

// 订阅详情
export function getSubscription(contractId) {
  return http.get(`/merContract/getSubContract?contractId=${contractId}`);
}

// 导出
export function exportSubscriptionList(params) {
  return http.get('/merContract/download', params);
}

// 取消订阅-新的，带到期时间
export function unsubscribeV2(params) {
  return http.post('/merContract/cancelSubscription', params);
}

// 详情导出
export function exportSubscriptionDetail(params) {
  return http.get(`/merContract/txnRecord/download/?contractId=${params}`);
}

// 获取订阅提醒
export function getEmailNotification(params) {
  return http.get('/merchant/subscriptionSetting/getEmailNotificationStatus', params);
}

// 订阅提醒邮件开关
export function updateEmailNotification(params) {
  return http.post(`/merchant/subscriptionSetting/updateEmailNotification?emailNotificationOnOff=${params}`);
}

// 编辑
export function updateSubscriptionDetail(params) {
  return http.post('/merContract/update', params);
}
